<template>
	<progress
		class="progress is-small is-primary"
		max="100"
	/>
</template>

<script>
export default {
	props: {

	},

	methods: {

	}
};
</script>
